package com.example.mystybag.login.views.views

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.DefaultButtonType
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p114
import com.example.mystybag.core.ui.theme.LocalTheme.p152
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.login.logic.AddFirstBagPromptViewModel
import com.example.mystybag.login.views.components.MerchantRegistrationWebBoundedColumn
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun AddFirstBagPromptWebView(viewModel: AddFirstBagPromptViewModel) {
    val colors = AppTheme.current.colors
    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        horizontalAlignment = Alignment.CenterHorizontally
    ) { _ ->
        MerchantRegistrationWebBoundedColumn(Modifier.fillMaxSize()) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .verticalScroll(rememberScrollState())
                    .padding(horizontal = p16)
                    .padding(top = p24, bottom = p8),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Top
            ) {
                Image(
                    painter = painterResource(SRC.images.add_first_bag_icon),
                    contentDescription = null,
                    modifier = Modifier
                        .height(p152)
                        .width(p114)
                        .padding(bottom = p32),
                    contentScale = ContentScale.Fit
                )

                Texts.HeadlineLarge(
                    text = stringResource(SR.strings.add_first_bag),
                    textAlign = TextAlign.Center,
                    color = colors.onSurface,
                    modifier = Modifier.fillMaxWidth()
                )

                Spacer(modifier = Modifier.height(p16))

                Texts.BodyLarge(
                    text = stringResource(SR.strings.add_first_bag_message),
                    textAlign = TextAlign.Center,
                    color = colors.onSurface,
                    modifier = Modifier.fillMaxWidth()
                )

                Spacer(modifier = Modifier.height(p32))

                DefaultButton(
                    type = DefaultButtonType.TERTIARY,
                    caption = stringResource(SR.strings.skip_for_now),
                    callback = { viewModel.onSkipClicked() },
                    modifier = Modifier.padding(bottom = p8)
                )

                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    DefaultButton(
                        caption = stringResource(SR.strings.start_adding_bag),
                        callback = { viewModel.onStartAddingBag() },
                        modifier = Modifier.fillMaxWidth(0.5f)
                    )
                }
            }
        }
    }
}
